import clsx from 'clsx';
import InputWrapper from '../inputField/InputWrapper';
import { InputState, Link } from '../inputField/types';
import { getOutlineColor } from '../inputField/utils';
import { SearchIcon } from '../svg';
import React from 'react';

type InputAttributes = React.InputHTMLAttributes<HTMLInputElement>;

type Props = {
  label?: string;
  id: InputAttributes['id'];
  name?: InputAttributes['name'];
  subText?: string;
  placeholder?: InputAttributes['placeholder'];
  value?: InputAttributes['value'];
  helperText?: string;
  link?: Link;
  inputState?: InputState;
  disabled?: InputAttributes['disabled'];
  onChange?: (value: string) => void;
  onEnterPressed?: () => void;
  type?: InputAttributes['type'] | 'textarea';
  className?: string;
  icon?: React.ReactNode;
};

const TextInputOld = ({
  id,
  name,
  placeholder,
  label,
  subText,
  helperText,
  link,
  disabled,
  inputState,
  value,
  onChange,
  onEnterPressed,
  type = 'text',
  className = '',
  icon,
}: Props) => {
  const styles = clsx(
    'box-border rounded-6 border-1 border-monochrome-3 px-16 py-8 text-md2 leading-7 disabled:cursor-not-allowed disabled:bg-white-100 disabled:opacity-40 disabled:placeholder:text-monochrome-6',
    getOutlineColor(inputState?.type),
    className
  );

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (event.key === 'Enter' && onEnterPressed) {
      onEnterPressed();
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (onChange) {
      onChange(event.target.value);
    }
  };

  const baseProps = {
    id,
    disabled,
    name: name ?? id,
    placeholder,
    className: styles,
    value: value,
    onChange: handleChange,
    onKeyPress: handleKeyPress,
  };
  const inputProps = { ...baseProps, type };
  const textareaProps = { ...baseProps, rows: 3 };

  return (
    <InputWrapper id={id} label={label} subText={subText} helperText={helperText} link={link} inputState={inputState}>
      {type === 'textarea' ? (
        <textarea {...textareaProps} />
      ) : icon ? (
        <div className={`flex items-center`}>
          <div className="absolute ml-8">
            <SearchIcon />
          </div>
          <input {...inputProps} className={`${styles} pl-40`} />
        </div>
      ) : (
        <input {...inputProps} />
      )}
    </InputWrapper>
  );
};

export default TextInputOld;
